// todo: once the reupload endpoint has been created, change these values to match
export enum ReuploadReason {
    DocumentDoesNotMatch = 'DocumentDoesNotMatch',
    CopyNotLegible = 'CopyNotLegible',
    DocumentExpired = 'DocumentExpired',
    PictureIsNotApplicant = 'PictureIsNotApplicant'
}



// WEBPACK FOOTER //
// ./src/dtos/reupload-reason.ts